import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "../css/WriterCss.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import config from '../includes/ConfigFile';
import getUser from '../includes/UserHelper';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';

const Writer = () => {
  const user = getUser();
  const { postId } = useParams();

  
  // NEW: Steps
  const [step, setStep] = useState(1);
  const nextStep = () => setStep((s) => s + 1);
  const prevStep = () => setStep((s) => s - 1);

  const [formData, setFormData] = useState({
    userId: user?.id || "",
    language: "",
    category: "",
    subcategory: "",
    authorName: user?.name || "",
    postTitle: "",
    shortDescription: "",
    postCoverImage: null,
    chapters: [{ chapterTitle: "", postContent: "" }],
  });

  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [categoryData, setCategoryData] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  
  const [selectedSubcategoryName, setSelectedSubcategoryName] = useState("");
  useEffect(() => {
  console.log("Selected Subcategory 👉", selectedSubcategoryName);
}, [selectedSubcategoryName]);

  useEffect(() => {
    if (!postId) {
      axios
        .get(`${config.BASE_URL}/api/languages`)
        .then((res) => setLanguages(res.data))
        .catch((err) => console.error("Error fetching languages:", err));
    }
  }, [postId]);

  useEffect(() => {
    if (selectedLanguage?.id) {
      axios
        .get(`${config.BASE_URL}/api/categories/${selectedLanguage.id}`)
        .then((res) => setCategoryData(res.data))
        .catch((err) => console.error("Error fetching categories:", err));
    } else {
      setCategoryData([]);
    }

    setFormData((prev) => ({ ...prev, category: "", subcategory: "" }));
    setSubcategories([]);
  }, [selectedLanguage]);

  useEffect(() => {
    if (selectedLanguage?.id && formData.category) {
      axios
        .get(
          `${config.BASE_URL}/api/subcategories/${selectedLanguage.id}/${formData.category}`
        )
        .then((res) => setSubcategories(res.data))
        .catch((err) => console.error("Error fetching subcategories:", err));
    } else {
      setSubcategories([]);
    }
  }, [selectedLanguage, formData.category]);

  const handleChange = (e, index = null) => {
    const { name, value } = e.target;

    if (index !== null) {
      const updatedChapters = [...formData.chapters];
      updatedChapters[index][name] = value;
      setFormData((prev) => ({ ...prev, chapters: updatedChapters }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));

      if (name === "language") {
        const langObj = languages.find((l) => String(l.id) === value);
        setSelectedLanguage(langObj || null);
      }
      //  SUBCATEGORY NAME TRACK
    if (name === "subcategory") {
      const subObj = subcategories.find(
        (s) => String(s.sub_cat_id) === value
      );
      setSelectedSubcategoryName(subObj?.name || "");
    }
    }
  };

  const handleImageChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      postCoverImage: e.target.files[0],
    }));
  };

  const handleAddChapter = () => {
    setFormData((prev) => ({
      ...prev,
      chapters: [...prev.chapters, { chapterTitle: "", postContent: "" }],
    }));
  };

  const handleSubmit = async (status) => {
    try {
      const data = new FormData();
      data.append("userId", formData.userId);
      data.append("status", status);
      data.append("chapters", JSON.stringify(formData.chapters));

      if (postId) {
        data.append("postId", postId);

        const response = await axios.post(
          `${config.BASE_URL}/api/addChapter`,
          data
        );

        toast.success(response.data.message || "Chapter added successfully!");
      } else {
        data.append("language", formData.language);
        data.append("category", formData.category);
        data.append("subcategory", formData.subcategory);
        data.append("authorName", formData.authorName);
        data.append("postTitle", formData.postTitle);
        data.append("shortDescription", formData.shortDescription);

        if (formData.postCoverImage) {
          data.append("postCoverImage", formData.postCoverImage);
        }

        const response = await axios.post(
          `${config.BASE_URL}/api/savePost`,
          data
        );

        toast.success(response.data.message || "Post submitted successfully!");
      }

      setFormData({
        userId: user?.id || "",
        language: "",
        category: "",
        subcategory: "",
        authorName: "",
        postTitle: "",
        shortDescription: "",
        postCoverImage: null,
        chapters: [{ chapterTitle: "", postContent: "" }],
      });

      setSelectedLanguage(null);
      setCategoryData([]);
      setSubcategories([]);
      setStep(1);
    } catch (error) {
      console.error("Error submitting:", error);
      alert("Something went wrong!");
    }
  };

  return (
    <>
      <Helmet>
        <title>Writer | {postId ? "Add Chapter" : "Write Your Story"}</title>
      </Helmet>

      <div className="container mx-auto mt-10 p-8 bg-gray-900 text-white rounded-lg shadow-lg max-w-4xl">
        <h2 className="text-3xl font-bold text-center mb-10">
          {postId ? "📚 Add New Chapter" : "✍️ Write Your Story"}
        </h2>

        {/* STEP INDICATOR */}
        {/* {!postId && (
          <div className="flex justify-center mb-6 gap-3">
            {["Step 1", "Step 2", "Step 3"].map((label, i) => (
              <div
                key={i}
                className={`px-4 py-2 rounded ${
                  step === i + 1 ? "bg-blue-600" : "bg-gray-700"
                }`}
              >
                {label}
              </div>
            ))}
          </div>
        )} */}

        <form className="writer-form">
          {/* ---------------- STEP 1 ---------------- */}
          {!postId && step === 1 && (
            <div className="row gy-4">
              <div className="col-md-6">
                <label className="form-label">Select Language</label>
                <select
                  name="language"
                  value={formData.language}
                  onChange={handleChange}
                  className="form-control bg-gray-800"
                >
                  <option value="">-- Select Language --</option>
                  {languages.map((lang) => (
                    <option key={lang.id} value={lang.id}>
                      {lang.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Select Category</label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  className="form-control bg-gray-800"
                >
                  <option value="">-- Select Category --</option>
                  {categoryData.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.category_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12">
                <label className="form-label">Subcategory</label>
                <select
                  name="subcategory"
                  value={formData.subcategory}
                  onChange={handleChange}
                  className="form-control bg-gray-800"
                >
                  <option value="">-- Select Subcategory --</option>
                  {subcategories.map((sub) => (
                    <option key={sub.sub_cat_id} value={sub.sub_cat_id}>
                      {sub.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12 d-flex justify-content-end mt-4">
                <button type="button" className="btn btn-primary" onClick={nextStep}>
                  Next ➜
                </button>
              </div>
            </div>
          )}

          {/* ---------------- STEP 2 ---------------- */}
          {!postId && step === 2 && (
            <div className="row gy-4">
              <div className="col-md-6">
                <label className="form-label">Author Name</label>
                <input
                  type="text"
                  name="authorName"
                  value={formData.authorName}
                  readOnly 
                  onChange={handleChange}
                  className="form-control bg-gray-800"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Novel/Story Name</label>
                <input
                  type="text"
                  name="postTitle"
                  value={formData.postTitle}
                  onChange={handleChange}
                  className="form-control bg-gray-800"
                />
              </div>

              <div className="col-12">
                <label className="form-label">Short Description</label>
                <textarea
                  name="shortDescription"
                  rows="4"
                  value={formData.shortDescription}
                  onChange={handleChange}
                  className="form-control bg-gray-800"
                ></textarea>
              </div>

              <div className="col-12">
                <label className="form-label">Post Cover Image</label>
                <input
                  type="file"
                  name="postCoverImage"
                  onChange={handleImageChange}
                  className="form-control bg-gray-800"
                />
              </div>

              <div className="col-12 d-flex justify-content-between mt-4">
                <button type="button" className="btn btn-secondary" onClick={prevStep}>
                  ⬅ Back
                </button>
                <button type="button" className="btn btn-primary" onClick={nextStep}>
                  Next ➜
                </button>
              </div>
            </div>
          )}

          {/* ---------------- STEP 3 ---------------- */}
          {step === 3 && (
            <>
              {formData.chapters.map((chapter, index) => (
                <div key={index} className="chapter-section">
                  {/* <div className="col-12">
                    <label className="form-label">Chapter Title</label>
                    <input
                      type="text"
                      name="chapterTitle"
                      value={chapter.chapterTitle}
                      onChange={(e) => handleChange(e, index)}
                      className="form-control bg-gray-800"
                    />
                  </div> */}
                  {/* SHOW ONLY FOR NOVEL */}
                {(selectedSubcategoryName === "Novel" || selectedSubcategoryName === "उपन्यास") && (
                  <div className="col-12">
                    <label className="form-label">Chapter Title</label>
                    <input
                      type="text"
                      name="chapterTitle"
                      value={chapter.chapterTitle}
                      onChange={(e) => handleChange(e, index)}
                      className="form-control bg-gray-800"
                    />
                  </div>
                )}

                  <div className="col-12 mt-3">
                    <label className="form-label">Your Story</label>
                    <ReactQuill
                      theme="snow"
                      value={chapter.postContent}
                      onChange={(content) => {
                        const updated = [...formData.chapters];
                        updated[index].postContent = content;
                        setFormData((prev) => ({
                          ...prev,
                          chapters: updated,
                        }));
                      }}
                      className="bg-white text-black"
                    />
                  </div>
                </div>
              ))}

              <div className="col-12 mt-3">
                <button
                  type="button"
                  onClick={handleAddChapter}
                  className="btn btn-secondary"
                >
                  Add More Chapters
                </button>
              </div>

              <div className="d-flex justify-content-between mt-4">
                <button type="button" className="btn btn-secondary" onClick={prevStep}>
                  ⬅ Back
                </button>

                {/* SAME BUTTONS (draft + publish) */}
                <div className="d-flex gap-3">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => handleSubmit("draft")}
                  >
                    💾 Save to Draft
                  </button>

                  <button
                    type="button"
                    className="btn btn-warning"
                    onClick={() => handleSubmit("publish")}
                  >
                    🚀 {postId ? "Add Chapter" : "Publish Now"}
                  </button>
                </div>
              </div>
            </>
          )}
        </form>
      </div>
    </>
  );
};

export default Writer;
